import React from 'react';
import Navbar from '../Navbar';
import Footer from '../Footer';

const Company = () => {
    return (
        <div className="bg-black-100 min-h-screen flex flex-col">
            <Navbar />
            <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
                <div className="max-w-3xl mx-auto">
                    <h1 className="text-3xl font-bold text-white mb-4">About Rapid AI</h1>
                    <p className="text-lg text-gray-500 mb-8 leading-relaxed">
                    Rapid AI is an AI tech start-up that's dedicated to being on the cutting edge of AI technology for the benefit of the public. Our comprehensive product line includes RASAS, RASAI, RASINT, RASVAL, and RASCALS. We offer image annotation, AI image management, AI integration, AI validation, and customized AI solutions. <br/><br/>  Our services enable businesses to quickly and accurately label and categorize their image datasets, organize and manage large datasets, seamlessly incorporate AI capabilities into their existing systems, and develop accurate and reliable AI models and algorithms. Our mission is to provide top-quality AI services that help businesses thrive in the rapidly-evolving field of AI.
                    </p> 
                    <h2 className="text-xl font-bold text-white mb-4">Our Team</h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 h-48 w-[45vw]">
                        <div className="bg-white overflow-hidden shadow rounded-lg">
                            <div className="px-4 py-5 sm:p-6">
                                <h3 className="text-lg font-medium text-gray-900 mb-2">De'Mondre Zimmerman</h3>
                                <p className="text-gray-500">Technical Founder</p>
                            </div>
                        </div>
                            {/** 
                            <div className="bg-white overflow-hidden shadow rounded-lg">
                                <div className="px-4 py-5 sm:p-6">
                                    <h3 className="text-lg font-medium text-gray-900 mb-2">Blank</h3>
                                    <p className="text-gray-500">Co-Founder</p>
                                </div>
                            </div>
                            */}
                    </div>
                    <h2 className="text-xl font-bold text-white mt-12 mb-4">Our Services</h2>
                    <ul className="list-disc list-inside text-lg text-gray-500">
                        <li>AI Consulting</li>
                        <li>Custom AI Development</li>
                        <li>Data Analytics</li>
                        <li>Machine Learning</li>
                        <li>Natural Language Processing</li>
                        <li>Computer Vision</li>
                    </ul>
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default Company;
